<template>
  <div class="app">
    <component :is="layout()"></component>
  </div>
</template>

<script>
import DefaultLayout from "./layout/DefaultLayout.vue";
import NoneLayout from "./layout/NoneLayout.vue";

export default {
  components: {
    DefaultLayout,
    NoneLayout,
  },

  methods: {
    layout() {
      let layout = this.$route.meta.layout ? this.$route.meta.layout + '-layout' : 'default-layout'
      return layout
    },
  },
}

</script>

<style scoped>
.app {
  overscroll-behavior-y: none;
}
</style>
